export default __webpack_public_path__ + "img/a4cecfab6da767ec6567eaf431578c7d.png";